/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';
import moment from 'moment';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import Helmet from 'react-helmet';
import { withUrlGenerator } from '@folklore/react-app';
import 'whatwg-fetch';

import NewsCard from '../cards/News';
import BoxButton from '../partials/BoxButton';
import PulseLoader from '../partials/PulseLoader';

import { addNews as addNewsActions } from '../../actions/SiteActions';

import styles from '../../../styles/pages/news.scss';

const propTypes = {
    mobile: PropTypes.bool.isRequired,
    intl: PropTypes.shape({
        formatMessage: PropTypes.func,
    }).isRequired,
    page: PropTypes.shape({
        data: PropTypes.shape({
            blocks: PropTypes.array,
        }),
    }).isRequired,
    beforeDate: PropTypes.string,
    urlGenerator: PropTypes.shape({
        route: PropTypes.func,
    }).isRequired,
    news: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
    })),
    addNews: PropTypes.func.isRequired,
};

const defaultProps = {
    news: null,
    beforeDate: null,
};

class News extends PureComponent {
    constructor(props) {
        super(props);

        this.onNewsLoaded = this.onNewsLoaded.bind(this);
        this.renderCard = this.renderCard.bind(this);

        this.refCards = [];
        this.state = {
            endReached: false,
        };
    }

    componentDidMount() {
        const { news } = this.props;
        if (news === null) {
            this.fetchNews();
        }
    }

    componentDidUpdate(prevProps) {
        const beforeDateChanged = this.props.beforeDate !== prevProps.beforeDate;
        if (beforeDateChanged) {
            this.fetchNews();
        }
    }

    /* eslint-disable camelcase */
    onNewsLoaded({ data, next_page_url }) {
        this.props.addNews(data);
        if (next_page_url === null) {
            this.setState({
                endReached: true,
            });
        }
    }
    /* eslint-enable camelcase */

    fetchNews() {
        const { urlGenerator, beforeDate } = this.props;
        const url = `${urlGenerator.route('api.news')}${
            beforeDate !== null ? `?before=${beforeDate}` : ''
        }`;
        fetch(url)
            .then(response => response.json())
            .then(this.onNewsLoaded);
    }

    // eslint-disable-next-line class-methods-use-this
    renderCard(post, index) {
        const { mobile } = this.props;
        const alternate = (index + 1) % 2 !== 0;
        return (
            <div
                key={`post-${post.id}`}
                className={classNames({
                    [styles.card]: true,
                    [styles.alt]: alternate,
                })}
                ref={(ref) => {
                    this.refCards[index] = ref;
                }}
            >
                <NewsCard
                    {...post}
                    mobile={mobile}
                    date={post.created_at}
                    direction={alternate ? 'left' : 'right'}
                />
            </div>
        );
    }

    renderPagination() {
        const { news, page } = this.props;
        const lastPostDate = moment(
            get(news, `${news.length - 1}.created_at`, null),
            'YYYY-MM-DD HH:mm:ss',
        ).format('YYYY-MM-DD');
        return (
            <div className={styles.pagination}>
                <BoxButton
                    label={{
                        id: 'content.older_posts',
                        defaultMessage: 'Older posts',
                    }}
                    red
                    link={`${page.url}?before=${lastPostDate}`}
                />
            </div>
        );
    }

    render() {
        const { intl, page, news } = this.props;
        const { endReached } = this.state;
        const { formatMessage } = intl;

        return (
            <div className={styles.container}>
                <Helmet>
                    <title>
                        {formatMessage(
                            {
                                id: 'meta.title_page',
                                defaultMessage: 'Accueil',
                            },
                            {
                                title: get(page, 'title', ''),
                            },
                        )}
                    </title>
                </Helmet>
                <div
                    className={classNames({
                        [styles.section]: true,
                        [styles.header]: true,
                    })}
                >
                    <div className={styles.cols}>
                        <div
                            className={classNames({
                                [styles.col]: true,
                                [styles.colTitle]: true,
                            })}
                        >
                            <h1 className={styles.title}>
                                {get(page, `data.title.${intl.locale}`, null)}
                            </h1>
                        </div>
                    </div>
                </div>
                <div
                    className={classNames({
                        [styles.section]: true,
                        [styles.list]: true,
                    })}
                >
                    {news !== null ? news.map(this.renderCard) : null}
                    {news === null ? (
                        <div className={styles.loading}>
                            <PulseLoader color="#8d877b" />
                        </div>
                    ) : null}
                    {news !== null && !endReached ? this.renderPagination() : null}
                </div>
            </div>
        );
    }
}

News.propTypes = propTypes;
News.defaultProps = defaultProps;

const mapStateToProps = ({ site, layout }, { location }) => ({
    ...layout.size,
    mobile: layout.mobile,
    beforeDate: get((location.search || '').match(/before=([^&]+)/), 1, null),
    page:
        site.page !== null && site.page.url === location.pathname
            ? site.page
            : site.pages.find(it => it.url === location.pathname) || null,
    news: site.news,
});
const mapDispatchToProps = dispatch => ({
    addNews: items => dispatch(addNewsActions(items)),
});
const WithStateContainer = connect(mapStateToProps, mapDispatchToProps)(News);
const WithUrlGeneratorContainer = withUrlGenerator()(WithStateContainer);
const WithIntlContainer = injectIntl(WithUrlGeneratorContainer);
const WithRouterContainer = withRouter(WithIntlContainer);

export default WithRouterContainer;



// WEBPACK FOOTER //
// ./js/components/pages/News.jsx